import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgInfoCircle = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M10 1.25a8.75 8.75 0 10.001 17.501A8.75 8.75 0 0010 1.25zm0 16.016a7.267 7.267 0 010-14.532 7.267 7.267 0 010 14.532z" />
      <Path d="M9.063 6.563a.937.937 0 101.874 0 .937.937 0 00-1.874 0zm1.406 2.187H9.53a.157.157 0 00-.156.156v5.313c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V8.906a.157.157 0 00-.156-.156z" />
    </Icon>
  );
};

export default SvgInfoCircle;
